import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppGlobalsModule } from '../app-globals.module';
import { map, shareReplay } from 'rxjs/operators';
import { YeshivaModels } from 'src/serverTypes/yeshivaTypesDeclare';
import { I18nService } from '../core/services/i18n/i18n.service';
import { AngularPages, UrlAddressService } from '../core/services/url-address/url-address.service';
//import { YeshivaModels } from "../serverTypes/yeshivaTypes";

const SERIES_PAGE_SIZE = AppGlobalsModule.NumberOfLessonsInPage;

@Injectable()
export class SeriesService {
    private http = inject(HttpClient);
    private _i18n = inject(I18nService);
    private url = inject(UrlAddressService);
    constructor() {
        this.isHeb = this._i18n.langIsHeb();
    }

    private seriesUrl = AppGlobalsModule.apiPath('seriesDetails');
    private allSeriesesUrl = AppGlobalsModule.apiPath('serieses/latest_series_no_lessons');
    private seriesDesktopUrl = AppGlobalsModule.apiPath('serieses/latest_series_with_lessons');
    private seriesByRavDesktopUrl = AppGlobalsModule.apiPath('serieses/latest_series_by_rav_with_lessons');
    private seriesesByMainCategories = AppGlobalsModule.apiPath('serieses/serieses_in_categories?ids=2232,1026,334,994,1880,1876,1879,7');
    private seriesesByMainCategoriesQuickNav = AppGlobalsModule.apiPath('serieses/serieses_in_categories?ids=2232,1026,334,994,1880,1876,1879,7');
    private engSeriesesByMainCategories = AppGlobalsModule.apiPath('serieses/serieses_in_categories?ids=334');
    public isHeb: boolean;
    public AngularPages = AngularPages;
    public seriesDisplay = false;
    public async getSeries(id: number, skip: number = 0) {
        let page: number = Math.floor(skip / SERIES_PAGE_SIZE) + 1;

        return this.http.get<YeshivaModels.BE.Series>(this.seriesUrl + `/${id}` + (skip > 1 ? `?page=${page}` : '')).toPromise();
    }
    public seriesesContainerPromise: Promise<YeshivaModels.BE.SeriesesContainer[] | undefined> | undefined;
    public shiurSeriesPromise: Promise<Map<number, YeshivaModels.BE.ShiurSeries> | undefined> | undefined;

    public getMainCatsSeries() {
        if (this.seriesesContainerPromise) {
            return this.seriesesContainerPromise;
        }
        if (this.seriesDisplay) {
            this.seriesesContainerPromise = this.http
                .get<YeshivaModels.BE.SeriesesContainer[]>(this.seriesesByMainCategoriesQuickNav)
                .pipe(shareReplay({ bufferSize: 1, refCount: true }))
                .toPromise();
            return this.seriesesContainerPromise;
        } else if (this.isHeb) {
            this.seriesesContainerPromise = this.http
                .get<YeshivaModels.BE.SeriesesContainer[]>(this.seriesesByMainCategories)
                .pipe(shareReplay({ bufferSize: 1, refCount: true }))
                .toPromise();
            return this.seriesesContainerPromise;
        } else {
            this.seriesesContainerPromise = this.http
                .get<YeshivaModels.BE.SeriesesContainer[]>(this.engSeriesesByMainCategories)
                .pipe(shareReplay({ bufferSize: 1, refCount: true }))
                .toPromise();
            return this.seriesesContainerPromise;
        }
    }

    public async getAllSeries() {
        if (this.shiurSeriesPromise) {
            return this.shiurSeriesPromise;
        }
        this.shiurSeriesPromise = this.http
            .get<YeshivaModels.BE.ShiurSeries[]>(this.allSeriesesUrl + '?all=true')
            .pipe(map((serieses: YeshivaModels.BE.ShiurSeries[]) => new Map(serieses.map((series) => [series.category?.Id, series]))))
            .toPromise();
        return this.shiurSeriesPromise;
    }
    public async getSeriesHomePage(numOfSeries: number = 6) {
        return this.http
            .get<YeshivaModels.BE.Series[]>(this.seriesDesktopUrl + `?numOfSeries=${numOfSeries}`)
            .pipe(shareReplay({ bufferSize: 1, refCount: true }))
            .toPromise();
    }
    public async getSeriesByRav(ravId: number) {
        return this.http
            .get<YeshivaModels.BE.Series[]>(this.seriesByRavDesktopUrl + `?ravid=${ravId}`)
            .pipe(shareReplay({ bufferSize: 1, refCount: true }))
            .toPromise();
    }
}
